import React, { useState } from "react";
import styles from "./PCBForm.module.css";
import { Field, Formik, Form } from "formik";
import {
  Button,
  InputGroup,
  Form as BootstrapForm,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import * as Yup from "yup";
import { submitFormPCB } from "../../actions/Form.action";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { MultiSelect } from "@mantine/core";

const PCBForm = ({ submitFormPCB, data }) => {
  const [submitting, setSubmitting] = useState(false);
  const [file, setFile] = useState(false);
  const navigate = useNavigate();
  const onSubmitHandeler = async (values) => {
    setSubmitting(true);
    if (!file) {
      toast.error("Please upload file!");
      setSubmitting(false);
      return;
    }
    if (Object.keys(data).length === 0) {
      toast.error("Please fill these fields!");
      setSubmitting(false);
      navigate("/order");
      return;
    }
    let check = await submitFormPCB(values, data, file);
    if (check === true) {
      setSubmitting(false);
      navigate(`/`);
    } else {
      setSubmitting(false);
    }
  };
  let initVals = {
    designNeeded: "Yes",
    layers: "Single Layer",
    finishing: [],
    details: "",
    quantity: "",
  };

  const OrderSchema = Yup.object().shape({
    designNeeded: Yup.string().notRequired(),
    layers: Yup.string().notRequired(),
    finishing: Yup.array().required("Finishing is required!"),
    details: Yup.string().required("Details is required!"),
    quantity: Yup.string().required("Quantity  is required!"),
  });

  return (
    <div className={styles.wrapper}>
      <h2 className="pt-4 px-5">PCB Manufacturing Order</h2>
      <Formik
        initialValues={initVals}
        validationSchema={OrderSchema}
        enableReinitialize
        onSubmit={(values) => onSubmitHandeler(values)}
      >
        {({ errors, touched, setFieldValue, values }) => (
          <Form>
            <Container className="p-md-5 p-3 pt-3 pt-md-3">
              <Row>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="designNeeded" className="d-block">
                        Design needed by TechnoWren?
                      </label>
                      {errors.designNeeded && touched.designNeeded ? (
                        <small className="text-danger">
                          {errors.designNeeded}
                        </small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Select}
                      name="designNeeded"
                      isValid={!errors.designNeeded && touched.designNeeded}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.designNeeded && touched.designNeeded}
                    >
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Field>
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="layers" className="d-block">
                        Layers
                      </label>
                      {errors.layers && touched.layers ? (
                        <small className="text-danger">{errors.layers}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Select}
                      name="layers"
                      isValid={!errors.layers && touched.layers}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.layers && touched.layers}
                    >
                      <option value="Single Layer">Single Layer</option>
                      <option value="Double Layer (No Plated Through Hole)">
                        Double Layer (No Plated Through Hole)
                      </option>
                    </Field>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="finishing" className="d-block">
                        Finishing
                      </label>
                      {errors.finishing && touched.finishing ? (
                        <small className="text-danger">
                          {errors.finishing}
                        </small>
                      ) : null}
                    </div>
                    <Field
                      as={MultiSelect}
                      data={[
                        "Solder Mask",
                        "Silk Screen Printing",
                        "Tinning",
                        "Component Placement",
                      ]}
                      onChange={(e) => setFieldValue("finishing", e)}
                      searchable
                      creatable
                      value={values.finishing}
                      getCreateLabel={(query) => `+ Create ${query}`}
                      onCreate={(query) => {
                        const item = { value: query, label: query };
                        return item;
                      }}
                      placeholder="Type finishing category..."
                      name="finishing"
                      isValid={!errors.finishing && touched.finishing}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.finishing && touched.finishing}
                    />
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="details" className="d-block">
                        Details
                      </label>
                      {errors.details && touched.details ? (
                        <small className="text-danger">{errors.details}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your details..."
                      name="details"
                      isValid={!errors.details && touched.details}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.details && touched.details}
                    ></Field>
                  </InputGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="quantity" className="d-block">
                        Quantity (According to the files)
                      </label>
                      {errors.quantity && touched.quantity ? (
                        <small className="text-danger">{errors.quantity}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your quantity ..."
                      name="quantity"
                      isValid={!errors.quantity && touched.quantity}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.quantity && touched.quantity}
                    />
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <BootstrapForm.Group controlId="formFile" className="mb-3">
                    <BootstrapForm.Label>
                      PCB Manufacturing Files *
                    </BootstrapForm.Label>
                    <BootstrapForm.Control
                      onChange={(e) => setFile(e.target?.files)}
                      type="file"
                      multiple
                    />
                  </BootstrapForm.Group>
                </Col>
              </Row>

              <Row>
                <Col className="pt-3 d-flex justify-content-center align-items-center">
                  <Button
                    type="submit"
                    className={`.btn_primary ${styles.btn}`}
                    disabled={submitting}
                  >
                    {submitting ? "Submitting..." : "Order"}
                  </Button>
                </Col>
              </Row>
            </Container>
          </Form>
        )}
      </Formik>
    </div>
  );
};
const mapStateToProps = (state) => ({
  data: state.form.form,
});
export default connect(mapStateToProps, { submitFormPCB })(PCBForm);
